export default async function GetLoginAuditApi() {
  let res = '';
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/login-audit/summary`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((response) => { res = response; })
      .catch((error) => { res = error; });
  } catch (error) {
    res = error;
  }
  return res;
}
